import {withTranslation} from '@wix/yoshi-flow-editor'
import {MemberPageContext} from '../../../types/state'
import {connect} from '../../connect'
import {MobileDownloadTicketsButtonOwnProps, MobileDownloadTicketsButtonRuntimeProps} from './interfaces'
import {MobileDownloadTicketsButton as Presentation} from './mobile-download-tickets-button'

const mapRuntime = ({
  actions: {downloadTicketsAction},
  state,
}: MemberPageContext): MobileDownloadTicketsButtonRuntimeProps => ({
  tickets: state.tickets,
  downloadTicketsAction,
})

export const MobileDownloadTicketsButton = connect<
  MobileDownloadTicketsButtonOwnProps,
  MobileDownloadTicketsButtonRuntimeProps
>(mapRuntime)(withTranslation()(Presentation))
export * from './interfaces'
